class SearchHelper {

    getUserName = (user) => {
        if (user.firstname && user.lastname) return user.firstname + " " + user.lastname;
        if (user.first_name && user.last_name) return user.first_name + " " + user.last_name;
        if (user.username) return user.username;
        return user;
    }

    getUser = ({ users, item, el }) => {
        let found = users.find(entry => parseInt(entry.id) == parseInt(item[el.name]));
        if (found) return this.getUserName(found);
        else if (item[el.name]) return item[el.name];
        return "";
    }

    showUser = ({ users, userid }) => {
        let found = users.find(entry => parseInt(entry.id) === parseInt(userid));
        if (found) return this.getUserName(found);
        return "";
    }

    refreshObjects = ({ name, sorted, articleObjects, updateArticleObjects, formatMessage, objName, intlName }) => {
        let sortById = name + '_' + sorted;
        let upperSorted = sorted.toUpperCase();
        let data = {
            ...articleObjects[objName],
            currentSortName: formatMessage({ id: `data.article.${intlName}.${name}${upperSorted}` }),
            currentSortSorted: sorted,
            currentSortField: name, currentSortValue: sortById, currentSortTrigger: true
        };
        updateArticleObjects({ [objName]: data });
    }

}

export default SearchHelper = new SearchHelper();